import type { Namespace } from './types';
export const zh: Namespace = {
  orderAccount: {
    title: '兑换工作台',
    missingPair: {
      title: '缺少订单账号参数',
      hint: '这一屏的主体是「订单号 × Steam 账号」这一对，必须同时带上 order_no 与 username。',
    },
    fields: {
      orderNo: '订单号',
      username: 'Steam 用户名',
      state: '账号状态',
      loginStage: '登录阶段',
      region: '地区',
      expected: '需充金额',
      delta: '已充余额',
      card: '已充面额',
      remark: '备注',
      walletCode: '钱包码',
      balanceBefore: '兑前余额',
      balanceAfter: '兑后余额',
      detail: '失败原因',
      submittedBy: '提交人',
      createdAt: '创建时间',
      updatedAt: '更新时间',
    },
    basic: {
      title: '基本信息',
      // 写操作回执（2026-10-23 补）。
      amountSaved: '面额已更新',
    },
    redeem: {
      title: '提交兑换',
      placeholder: '一行一个钱包码',
      codeCount: '已填 {{count}} 个码',
      submit: '提交兑换',
      // 离线账号不接新兑换活（后端提交闸 409）⇒ 前端先拦一道，给准话。
      offline: '该账号当前离线，请先登录再提交兑换',
      // 202 = **受理**（worker 还没结算）⇒ 回执不能说「已兑换」。
      accepted: '兑换已受理，结果稍后刷新查看',
    },
    history: {
      title: '兑换历史',
      empty: '还没有兑换记录',
      search: {
        walletCode: '钱包码',
        state: '状态',
      },
    },
  },
};

export const en: Namespace = {
  orderAccount: {
    title: 'Redeem Workbench',
    missingPair: {
      title: 'Missing order-account parameters',
      hint: 'This screen is about one (order no. × Steam account) pair — both order_no and username are required.',
    },
    fields: {
      orderNo: 'Order no.',
      username: 'Steam username',
      state: 'Account state',
      loginStage: 'Login stage',
      region: 'Region',
      expected: 'Expected amount',
      delta: 'Balance added',
      card: 'Card value',
      remark: 'Note',
      walletCode: 'Wallet code',
      balanceBefore: 'Balance before',
      balanceAfter: 'Balance after',
      detail: 'Failure reason',
      submittedBy: 'Submitted by',
      createdAt: 'Created at',
      updatedAt: 'Updated at',
    },
    basic: {
      title: 'Basic info',
      // Write-operation receipts (2026-10-23).
      amountSaved: 'Amount updated',
    },
    redeem: {
      title: 'Submit codes',
      placeholder: 'One wallet code per line',
      codeCount: '{{count}} code(s) entered',
      submit: 'Submit',
      // An offline account takes no new redemption (backend gate → 409).
      offline: 'This account is offline — log in before submitting wallet codes',
      // 202 = **accepted** (the worker has not settled it yet).
      accepted: 'Redeem accepted — check the refreshed list for the result',
    },
    history: {
      title: 'Redeem history',
      empty: 'No redemptions yet',
      search: {
        walletCode: 'Wallet code',
        state: 'State',
      },
    },
  },
};
